import { render } from "./SummaryCard.vue?vue&type=template&id=ebab2fd6&scoped=true"
import script from "./SummaryCard.vue?vue&type=script&lang=js"
export * from "./SummaryCard.vue?vue&type=script&lang=js"

import "./SummaryCard.vue?vue&type=style&index=0&id=ebab2fd6&lang=scss&scoped=true"

import exportComponent from "/var/www/payment-hub-web-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebab2fd6"]])

export default __exports__